import { ArrivalScanResponse } from '../../services/arrivalScan.endpoints';
import { CheckCircleOutline } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';

interface SuccessViewProps {
  result: ArrivalScanResponse;
}

const SuccessView: React.FC<SuccessViewProps> = ({ result }) => {
  const statusLabel =
    result.finalStatus?.commercialName ||
    result.finalStatus?.name ||
    'Procesado';

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 10 }}>
        <CheckCircleOutline
          sx={{ fontSize: 40, color: 'white', opacity: 0.9 }}
        />
        <Typography
          variant='h4'
          sx={{
            fontWeight: 800,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            color: 'white',
          }}
        >
          Arribo Exitoso
        </Typography>
      </Box>

      <Box sx={{ textAlign: 'center', width: '100%', mb: 10 }}>
        <Typography
          variant='h1'
          sx={{
            fontWeight: 800,
            fontSize: { xs: '3.5rem', md: '6.5rem' },
            lineHeight: 1.1,
            textTransform: 'uppercase',
            letterSpacing: '-1px',
            color: 'white',
            fontFamily: 'Karla, sans-serif',
          }}
        >
          {statusLabel}
        </Typography>
      </Box>

      <Box
        sx={{
          bgcolor: 'rgba(255,255,255,0.15)',
          px: 4,
          py: 1.5,
          borderRadius: '16px',
          border: '1px solid rgba(255,255,255,0.2)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <Typography variant='h6' sx={{ fontWeight: 700, color: 'white', letterSpacing: '0.5px' }}>
          Pedido #{result.shippingNumber}
        </Typography>
      </Box>
    </Box>
  );
};

export default SuccessView;
